import React, { memo, useCallback, useMemo } from 'react';
import { QuickFilters } from '@Sage/ssm-web5';

import { getLiteral } from 'utils/getLiteral';

import { LEADS_LITERALS } from './literals';

const FILTER_IDS = ['businessType', 'maxResults', 'radius'];

const LeadsQuickFilters = ({
    category,
    categoryOptions,
    maxResults,
    maxResultOptions,
    radiusKm,
    radiusOptions,
    businessTypesLoading,
    businessTypesError,
    onChangeCategory,
    onChangeMaxResults,
    onChangeRadiusKm,
}) => {
    const flatCategoryOptions = useMemo(
        () =>
            (categoryOptions || []).flatMap((group) =>
                Array.isArray(group?.options) ? group.options : [group],
            ),
        [categoryOptions],
    );

    const schema = useMemo(
        () => [
            {
                id: 'businessType',
                label: getLiteral(LEADS_LITERALS.businessType),
                isRemovable: false,
                fields: [
                    {
                        id: 'businessType',
                        label: getLiteral(LEADS_LITERALS.businessType),
                        dataType: 'singleValueList',
                        inputProps: {
                            options: categoryOptions,
                            isClearable: false,
                            isDisabled: Boolean(businessTypesLoading || businessTypesError),
                        },
                    },
                ],
            },
            {
                id: 'maxResults',
                label: getLiteral(LEADS_LITERALS.maxResults),
                isRemovable: false,
                fields: [
                    {
                        id: 'maxResults',
                        label: getLiteral(LEADS_LITERALS.maxResults),
                        dataType: 'singleValueList',
                        inputProps: {
                            options: maxResultOptions,
                            isClearable: false,
                        },
                    },
                ],
            },
            {
                id: 'radius',
                label: getLiteral(LEADS_LITERALS.radius),
                isRemovable: false,
                fields: [
                    {
                        id: 'radius',
                        label: getLiteral(LEADS_LITERALS.radius),
                        dataType: 'singleValueList',
                        inputProps: {
                            options: radiusOptions,
                            isClearable: false,
                        },
                    },
                ],
            },
        ],
        [
            businessTypesError,
            businessTypesLoading,
            categoryOptions,
            maxResultOptions,
            radiusOptions,
        ],
    );

    const values = useMemo(
        () => ({
            businessType: flatCategoryOptions.find((item) => item.value === category),
            maxResults: maxResultOptions.find((item) => item.value === maxResults),
            radius: radiusOptions.find((item) => item.value === radiusKm),
        }),
        [category, flatCategoryOptions, maxResults, maxResultOptions, radiusKm, radiusOptions],
    );

    const handleChange = useCallback(
        ({ filter, value }) => {
            if (filter.id === 'businessType') onChangeCategory(value?.value ?? '');
            if (filter.id === 'maxResults') onChangeMaxResults(value?.value || '20');
            if (filter.id === 'radius') onChangeRadiusKm(value?.value || '2');
        },
        [onChangeCategory, onChangeMaxResults, onChangeRadiusKm],
    );

    return (
        <QuickFilters
            className="fm-leads-modal__quick-filters"
            filters={FILTER_IDS}
            schema={schema}
            values={values}
            onChange={handleChange}
            showAdd={false}
        />
    );
};

export default memo(LeadsQuickFilters);
